import { DeliveryTerm } from "src/api-service";

// **************************************************************************
// DELIVERY TERM STATE
// **************************************************************************
export interface DeliveryTermState {
    deliveryTerm: DeliveryTerm | null;
    deliveryTerms: DeliveryTerm[];
    deliveryTermsLoading: boolean;
}

export const initialDeliveryTermState: DeliveryTermState = {
    deliveryTerm: null,
    deliveryTerms: [],
    deliveryTermsLoading: false,
};
